import type { ComponentVariant } from 'src/modules/shared/types/component.type';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/** Presentation mappings for this settings UI; not a transport contract. */
export const getVerificationVariant = (status: string): ComponentVariant => {
  switch (status.toUpperCase()) {
    case 'VERIFIED':
      return 'success';
    case 'UNVERIFIED':
      return 'warning';
    case 'PENDING':
      return 'info';
    default:
      return 'neutral';
  }
};

/** Maps Meta quality ratings to the shared badge palette. */
export const getQualityVariant = (rating: string): ComponentVariant => {
  switch (rating.toUpperCase()) {
    case 'GREEN':
      return 'success';
    case 'YELLOW':
      return 'warning';
    case 'RED':
      return 'danger';
    default:
      return 'neutral';
  }
};

/** Selects a translated verification label, including unknown Meta values. */
export const getVerificationLabel = (status: string): TranslationKey => {
  switch (status.toUpperCase()) {
    case 'VERIFIED':
      return 'settings.integrations.whatsapp.phone.verified';
    case 'UNVERIFIED':
      return 'settings.integrations.whatsapp.phone.unverified';
    case 'PENDING':
      return 'settings.integrations.whatsapp.phone.pending';
    default:
      return 'settings.integrations.whatsapp.phone.unknown';
  }
};

/** Selects a translated quality label, including unrated phone numbers. */
export const getQualityLabel = (rating: string): TranslationKey => {
  switch (rating.toUpperCase()) {
    case 'GREEN':
      return 'settings.integrations.whatsapp.phone.quality.high';
    case 'YELLOW':
      return 'settings.integrations.whatsapp.phone.quality.medium';
    case 'RED':
      return 'settings.integrations.whatsapp.phone.quality.low';
    default:
      return 'settings.integrations.whatsapp.phone.quality.unrated';
  }
};
